import { createStyles } from '@material-ui/core/styles';
import checkedImg from '../../../theme/select-chk.svg';
import styled from 'styled-components';

const color = {
  black: '#38393c',
  blue: '#1387ba',
  gray: '#747474',
  lightgray: '#ebebeb',
  lightgray2: '#f1f1f1',
  lightgray3: '#f7f7f7',
  red: '#e91019'
};

export const MetricsTableStyles = theme =>
  createStyles({
    MetricsTable_table: {
      minWidth: 700,
      borderCollapse: 'separate'
    },
    MetricsTable_hover: {
      '& > tbody > tr:hover': {
        backgroundColor: color.lightgray3
      }
    },
    MetricsTable_chartedTable: {
      overflowX: 'scroll'
    },
    MetricsTable_tableWrapper: {},
    MetricsTable_chartedTableWrapper: {
      overflowX: 'scroll',
      overflowY: 'hidden',
      marginLeft: 515,
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    MetricsTable_body: {
      fontSize: 40
    },
    MetricsTable_PageOptionsSpacer: {
      flex: 1
    },
    MetricsTable_PageOptionsCaption: {
      marginLeft: 35
    },
    MetricsTable_geographyPickerIcon: {
      paddingLeft: 5
    },
    MetricsTable_TableIcons: {
      paddingLeft: 10
    },
    // Metric Name Col
    MetricsTable_MetricNameHead: {},
    MetricsTable_ChartedMetricNameHead: {
      width: 300,
      position: 'absolute',
      left: 50,
      height: 80,
      display: 'flex',
      alignItems: 'center',
      borderRight: `1px solid ${color.lightgray}`
    },
    MetricsTable_MetricName: {
      borderRight: `1px solid ${color.lightgray}`,
      display: 'flex',
      fontSize: 17,
      border: 'none',
      paddingTop: 14
    },
    MetricsTable_ChartedMetricName: {
      padding: '0x 0px 3px 5px',
      fontSize: '15px !important',
      height: 50,
      width: 300,
      position: 'absolute',
      left: 50,
      borderRight: `1px solid ${color.lightgray}`
      // borderBottom: `1px solid ${color.lightgray}`,
    },
    MetricsTable_ChartedMetricEmptyCell: {
      left: 0,
      width: 350,
      borderBottom: `1px solid ${color.lightgray}`
    },
    // Geo Col
    MetricsTable_MetricGeoHead: {},
    MetricsTable_ChartedMetricGeoHead: {
      backgroundColor: 'white',
      borderRight: `1px solid ${color.lightgray}`,
      width: 170,
      position: 'absolute',
      left: 350,
      height: 80,
      // borderRight: `1px solid ${color.lightgray}`,
      display: 'flex',
      alignItems: 'center',
      zIndex: 2
    },
    MetricsTable_MetricGeo: {},
    MetricsTable_ChartedMetricGeo: {
      fontSize: '12px',
      height: 50,
      width: 170,
      position: 'absolute',
      paddingTop: 9,
      left: 350,
      borderRight: `1px solid ${color.lightgray}`,
      zIndex: 1
    },
    MetricsTable_ChartedMetricAddButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    // Left Icon Col
    MetricsTable_IconCell: {
      border: 'none'
    },
    MetricsTable_ChartedIconCell: {
      position: 'absolute',
      left: 0,
      padding: '5px 12px 0 3px !important',
      // borderBottom: `1px solid ${color.lightgray}`,
      width: '50px !important',
      height: 50
    },
    MetricsTable_chartedIcon: {
      height: 80,
      position: 'absolute',
      left: 0
    },
    icon: {
      borderRadius: 3,
      width: 25,
      height: 25,
      backgroundColor: theme.color.lightgray
    },
    checkedIcon: {
      background: `url(${checkedImg}) no-repeat`
    },
    deletable: {
      '&:hover $deleteIcon': {
        visibility: 'visible',
        marginLeft: '-25px'
      },
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    MetricsTable_MetricNameWrapper: {
      width: 250,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginRight: 10
    },
    deleteIcon: {
      visibility: 'hidden',
      '&:hover': {
        background: 'transparent'
      }
    },
    MetricsTable_checkbox: {
      root: {
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      padding: 0
    },

    MetricsTable_tableHead: {},
    MetricsTable_chartedTableHead: {
      height: 80
    },
    MetricsTable_TableSort: {
      color: theme.color.gray
    },

    MetricsTable_chartIcon: {
      paddingTop: 10,
      width: 50,
      paddingRight: 0,
      paddingLeft: 27
    },
    MetricsTable_PageOptions: {
      borderBottom: 'none'
    },
    MetricsTable_Row: {
      height: 50
    },
    MetricsTable_ChartedMetricDataCell: {
      borderBottom: 'none',
      borderTop: 'none'
    },
    MetricsTable_SelectableGeographies: {
      marginRight: 0,
      fontSize: '14px',
      width: 95
    },
    MetricsTable_NoResultCells: {
      borderBottom: 'none'
    },
    MetricsTable_yearCells: {
      // backgroundColor: 'lime',
      padding: '6px 20px 6px 12px'
    },

    tableFooter: {
      margin: '-1px -5px 10px -5px',
      paddingTop: 10,
      display: 'flex',
      padding: '0 20px',
      justifyContent: 'space-between',
      borderTop: `1px solid ${color.lightgray}`
    },
    download: {
      paddingTop: 5,
      paddingRight: 15,
      cursor: 'pointer'
    },
    downloadCSV: {
      textDecoration: 'none'
    },
    iconButton: {
      padding: 0,
      '&:hover': {
        background: 'transparent'
      },
      borderRadius: 0
    },
    downloadLinkText: {
      fontFamily: theme.typography.fontFamily,
      color: '#e91019',
      marginRight: 10,
      display: 'inline-block',
      float: 'left',
      fontSize: '13px',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    modalWrapper: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: 400,
      backgroundColor: 'white',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      margin: '-220px 0 0 -226px',
      borderRadius: 4,
      border: '1px solid #EBEBEB'
    },
    modalClose: {
      float: 'right',
      position: 'relative',
      bottom: '10px',
      left: '27px',
      padding: '5px',
      margin: '0px'
    },
    modalText: {
      fontSize: 16,
      fontWeight: 400,
      display: 'block',
      margin: '8px 0 0 0'
    },
    modalTextBold: {
      fontSize: 16,
      fontWeight: 700,
      display: 'block',
      margin: '24px 0 0 0'
    },
    disabledRow: {
      color: '#A4A4A4'
    }
  });

export const SelectedTitle = styled.span`
  font-size: 14px;
  padding: 10px 25px;
  font-weight: 400;
  position: relative;
  top: 6px;
`;

export const SelectedTableBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 16px;
  max-height: 150px;
  border-bottom: 1px solid #ebebeb;
  overflow: hidden;
  overflow-y: auto;

  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  & {
    scrollbar-width: thin;
    scrollbar-color: ${color.gray} #ffffff;
  }

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${color.gray};
    border-radius: 10px;
    border: 2px solid #ffffff;
  }
`;

export const MetricRowIconWrapper = styled.div`
  display: inline-block;
  margin-right: 35px;
`;

export const MetricRowWrapper = styled.div`
  display: inline-block;
  border: none !important;
`;
